import { render, staticRenderFns } from "./workDetails.vue?vue&type=template&id=21f62f70"
import script from "./workDetails.vue?vue&type=script&lang=js"
export * from "./workDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f62f70')) {
      api.createRecord('21f62f70', component.options)
    } else {
      api.reload('21f62f70', component.options)
    }
    module.hot.accept("./workDetails.vue?vue&type=template&id=21f62f70", function () {
      api.rerender('21f62f70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/education/workDetails.vue"
export default component.exports